import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pairFilter',
  standalone: true,
})
export class PairFilterPipe implements PipeTransform {
  transform(items: any[], name: any, status: any, hidden: any, symbol: any) {
    return items.filter((item) => {
      if (item.isActive !== status && status !== 'any') {
        return false;
      }
      if (item.isHidden !== hidden && hidden !== 'any') {
        return false;
      }
      if (item.symbol !== symbol && symbol !== 'Any') {
        return false;
      }

      if (name) {
        const nameStr = name.toLowerCase();
        const itemBase = item.base.toLowerCase();
        const itemQuote = item.quote.toLowerCase();

        if (!(itemBase.includes(nameStr) || itemQuote.includes(nameStr))) {
          return false;
        }
      }
      return true;
    });
  }
}
